module.exports = __webpack_public_path__ + "img/Health.8d8e8b56.svg";